import request from "@/utils/request";

export default function adminGetNewsContentById(id) {
    return request({
        url: `/news/adminGetNewsById/`+id,
        method: 'get',
    })
}